import { styled } from '@mui/material/styles';
import React from 'react';
import { NavLink } from 'react-router-dom';

import { useChartPalette } from 'components/charts/hooks/use-chart-palette';
import { ChartPalette } from 'components/charts/types/chart-palette.type';

const Root = styled('div', {
  shouldForwardProp: (prop) => prop !== 'chartPalette',
})<{ chartPalette: ChartPalette }>(({ theme, chartPalette }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  overflowX: 'auto',
  paddingLeft: theme.spacing(4),
}));

const Tab = styled(NavLink, {
  shouldForwardProp: (prop) => prop !== 'chartPalette',
})<{ chartPalette: ChartPalette }>(({ theme, chartPalette }) => ({
  color: theme.palette.common.white,
  cursor: 'pointer',
  flexShrink: 0,
  fontSize: 14,
  fontWeight: 600,
  padding: theme.spacing(2, 4),
  textDecoration: 'none',
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,

  '&.active': {
    color: chartPalette.text.primary,
    backgroundColor: chartPalette.backgrounds.sunken,
  },
}));

const DataLabSubTabs: React.FC = () => {
  const chartPalette = useChartPalette();

  return (
    <Root chartPalette={chartPalette}>
      <Tab chartPalette={chartPalette} exact to="/playground/data-lab">
        Overview
      </Tab>
      <Tab chartPalette={chartPalette} exact to="/playground/data-lab/gallery">
        Gallery
      </Tab>
      <Tab chartPalette={chartPalette} exact to="/playground/data-lab/drill-down">
        Drill-down
      </Tab>
      <Tab chartPalette={chartPalette} exact to="/playground/data-lab/flow">
        Flow
      </Tab>
      <Tab chartPalette={chartPalette} exact to="/playground/data-lab/embedded">
        Embedded
      </Tab>
      <Tab chartPalette={chartPalette} exact to="/playground/data-lab/controls">
        Controls
      </Tab>
    </Root>
  );
};

export default React.memo(DataLabSubTabs);
